import React , {createContext, useContext, useState , ReactNode, useEffect} from 'react';
import PageTitle from '../../components/PageTitle';
import api from "../../api/axiosClient"
import genStyles from '../../styles/General.module.css'
import { Button, TextInput} from '@mantine/core';
import { useParams , useNavigate } from 'react-router-dom';
import { ModelsDetailRowType, ModelsRowType } from "../../types/models";
import ModelsDetailsList from './ModelsDetailsList';
import {useDisclosure } from '@mantine/hooks';
import ModelsDetailsPopUp from './ModelsDetailsPopUp';


const ModelsDetailsPage = () => {
    const [data, setData] = useState<ModelsDetailRowType[]>([]);
    const { activeTab, id } = useParams();
    const activeTabValue = activeTab ?? 'Color';
    const [modelName, setModelName] = useState('');
    const [savedModelName, setSavedModelName] = useState('');
    const [modelNameError, setModelNameError] = useState<string | null>(null);
    const [opened, { open, close }] = useDisclosure(false);


    const endpoints: Record<string, string> = {
            Color: 'colors',
            Recycling: 'recycling-categories',
            Reuse: 'reuse-categories',
    };

        const modelEndpoints: Record<string, string> = {
            Color: 'color-models',
            Recycling: 'recycling-models',
            Reuse: 'reuse-models',
        };


    const deleteDetail = async (id: number) => {
        const endpoint = endpoints[activeTabValue];
        await api.delete(`/sorter/model/${endpoint}/${id}`);
        const updatedData = data?.filter((item) => item.id !== id) || [];
        setData(updatedData);
    }
    

    useEffect(() => {
        const fetchModel = async () => {
        try {
            switch (activeTabValue) {
                case 'Color':
                    const response = await api.get<ModelsDetailRowType[]>(`/sorter/model/colors/model/${id}`);
                    setData(response.data);
                    break;
                case 'Recycling':
                    const response2 = await api.get<ModelsDetailRowType[]>(`/sorter/model/recycling-categories/model/${id}`);
                    setData(response2.data);
                    break;
                case 'Reuse':
                    const response3 = await api.get<ModelsDetailRowType[]>(`/sorter/model/reuse-categories/model/${id}`);
                    setData(response3.data);
                    break;
                default:
                    break;
            }
        }catch (error) {
            console.error("Error fetching models:", error);
            setData([])
        }};
        fetchModel();
    },  [activeTab, id]);

    useEffect(() => {
        const fetchModelName = async () => {
            const endpoint = modelEndpoints[activeTabValue];
            if (!endpoint || !id) return;

            try {
                const response = await api.get<ModelsRowType>(`/sorter/model/${endpoint}/${id}`);
                setModelName(response.data.name);
                setSavedModelName(response.data.name);
                setModelNameError(null);
            } catch (error) {
                console.error("Error fetching model name:", error);
                setModelName('');
                setSavedModelName('');
            }
        };
        fetchModelName();
    }, [activeTabValue, id]);

    const saveModelName = async () => {
        const endpoint = modelEndpoints[activeTabValue];
        const trimmedName = modelName.trim();
        if (!endpoint || !id) return;
        if (!trimmedName) {
            setModelNameError('Name is required');
            return;
        }

        try {
            const response = await api.put<ModelsRowType>(`/sorter/model/${endpoint}/${id}`, {
                id: Number(id),
                name: trimmedName,
            });
            setModelName(response.data.name);
            setSavedModelName(response.data.name);
            setModelNameError(null);
        } catch (error) {
            console.error("Error saving model name:", error);
            setModelNameError('Could not save model name');
        }
    }

    const onClickAdd = async (newCategory: ModelsDetailRowType) => {
        const endpoint = endpoints[activeTabValue];
        console.log("Adding new category", newCategory);
        if (newCategory.id === undefined || newCategory.id === -1) {
            newCategory.sorter_model_id = Number(id);
            console.log("Adding new category", newCategory);
            const response = await api.post(`/sorter/model/${endpoint}`, newCategory);
            console.log("Response from API:", response.data);
            const modelDetails = [...data, response.data]
            setData(modelDetails)
            close();
        } else {
            const response = await api.put(`/sorter/model/${endpoint}/${newCategory.id}`, newCategory);
            const updatedData = data?.map((item) => item.id === newCategory.id ? response.data : item) || [];
            setData(updatedData);
            close();
        }
    }

    const navigate = useNavigate();
    return(
        <div>
            <ModelsDetailsPopUp
                opened={opened}
                close={close}
                title={"Add"}
                onSave={onClickAdd}
                modelLabel={null}
                activeTab={activeTab}
                existingModelLabels={data.map((item) => item.model_label)}
            ></ModelsDetailsPopUp>
            <PageTitle title="Models Details" />
            <div className={genStyles.PageMain}>
                <div className={genStyles.ModelNameRow}>
                    <TextInput
                        className={genStyles.ModelNameInput}
                        label="Model name"
                        value={modelName}
                        onChange={(event) => {
                            setModelName(event.currentTarget.value);
                            setModelNameError(null);
                        }}
                        error={modelNameError}
                    />
                    <Button
                        className={genStyles.ModelNameButton}
                        onClick={saveModelName}
                        disabled={modelName.trim() === savedModelName.trim()}
                        variant="filled"
                        color="#474973"
                        radius="xl"
                    >
                        Save
                    </Button>
                </div>
                <ModelsDetailsList data={data} activeTab={activeTab ?? undefined} deleteDetail={deleteDetail} onSave={onClickAdd} ></ModelsDetailsList>
                 <div className={genStyles.AddButtonWrapper}> 
                     <Button className ={genStyles.LeftButton} onClick={() => {open()}} variant="filled" color="#474973" radius="xl">Add</Button>
                    <Button className ={genStyles.AddButton} onClick={ () => {navigate(`/models`)}} variant="outline" color="#474973" radius="xl">Back</Button>
                </div>
            </div>
        </div>
    )
}
export default ModelsDetailsPage;